// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GenerateWinninAIReportUseCaseModal {
  padding: 32px;
  background-color: var(--color_neutral_0);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: flex-start;
  justify-content: space-between;
}
.GenerateWinninAIReportUseCaseModal-actions {
  display: flex;
  justify-content: space-between;
  width: 100%;
}
.GenerateWinninAIReportUseCaseModal-actions > div {
  display: flex;
  gap: 24px;
}
.GenerateWinninAIReportUseCaseModal-content {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: flex-start;
}
.GenerateWinninAIReportUseCaseModal-reportTypes {
  max-width: 526px;
  display: flex;
  flex-direction: column;
  gap: 32px;
}
.GenerateWinninAIReportUseCaseModal-reportTypes .TerritoryAnalysisContent-description {
  color: #4c5667;
  color: var(--gray_dark2, #4c5667);
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
}
.GenerateWinninAIReportUseCaseModal-reportTypes label[for=brand],
.GenerateWinninAIReportUseCaseModal-reportTypes label[for=brandDescription] {
  color: var(--color_neutral_500);
  line-height: 18px;
}
.GenerateWinninAIReportUseCaseModal-reportTypes .TerritoryAnalysisContent-brandDescription {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.GenerateWinninAIReportUseCaseModal-reportTypes .TerritoryAnalysisContent-brandDescription span {
  color: #9ba1ad;
  color: var(--color_neutral_500, #9ba1ad);
  text-align: left;
  font-size: 10px;
  font-weight: 400;
}`, "",{"version":3,"sources":["webpack://./src/components/GenerateWinninAIReportUseCaseModal/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,uBAAA;EACA,8BAAA;AACF;AACE;EACE,aAAA;EACA,8BAAA;EACA,WAAA;AACJ;AAAI;EACE,aAAA;EACA,SAAA;AAEN;AAEE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,uBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AADJ;AAGI;EACE,cAAA;EAAA,iCAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AADN;AAII;;EAEE,+BAAA;EACA,iBAAA;AAFN;AAKI;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAHN;AAKM;EACE,cAAA;EAAA,wCAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AAHR","sourcesContent":[".GenerateWinninAIReportUseCaseModal {\n  padding: 32px;\n  background-color: var(--color_neutral_0);\n  border-radius: 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 32px;\n  align-items: flex-start;\n  justify-content: space-between;\n\n  &-actions {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    > div {\n      display: flex;\n      gap: 24px;\n    }\n  }\n\n  &-content {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    align-items: flex-start;\n  }\n\n  &-reportTypes {\n    max-width: 526px;\n    display: flex;\n    flex-direction: column;\n    gap: 32px;\n\n    .TerritoryAnalysisContent-description {\n      color: var(--gray_dark2, #4c5667);\n      font-size: 14px;\n      font-weight: 400;\n      line-height: 150%;\n    }\n\n    label[for='brand'],\n    label[for='brandDescription'] {\n      color: var(--color_neutral_500);\n      line-height: 18px;\n    }\n\n    .TerritoryAnalysisContent-brandDescription {\n      display: flex;\n      flex-direction: column;\n      gap: 2px;\n\n      span {\n        color: var(--color_neutral_500, #9ba1ad);\n        text-align: left;\n        font-size: 10px;\n        font-weight: 400;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
